var storagePrefix = "static";
window.htUrl = function(path) {
  if (path) {
    storagePrefix = "models/" + path;
  }
  return storagePrefix;
};
window.htconfig = {
  Default: {
    convertURL: function(url) {
      if (
        storagePrefix &&
        url &&
        !/^data:image/.test(url) &&
        !/^http/.test(url) &&
        !/^https/.test(url)
      ) {
        url = storagePrefix + "/" + url;
      }
      return url;
    }
  }
};
